import type { App } from "vue";

import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import { Plugin } from "vue";
import "highcharts/modules/accessibility";
import "highcharts/modules/pattern-fill";
import "highcharts/modules/heatmap";

export function setChartsLocale(locale: string) {
  Highcharts.setOptions({
    lang: {
      locale,
    },
  });
}

const highchartsPlugin: Plugin = {
  install(app: App) {
    app.use(HighchartsVue, {
      highcharts: Highcharts,
    });
  },
};

export default highchartsPlugin;
